import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Item, Input, Button, Icon, Table, Select, DatePicker, Radio } from 'antd';
import { createShowAddAction, addUser, getList } from '../../actions/user';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};
/**
 * 弹窗组件
 */
class Add extends React.Component {
    constructor(props) {
        super(props);
    };
    // 提交编辑
    async addUser(id) {
        this.props.form.validateFields(async (err, fieldsValue) => {
            if (!err) {
                try {
                    await this.props.addUser(fieldsValue);
                    await this.props.form.resetFields();
                    await this.props.getList({page:this.props.page,pageSize:this.props.pageSize});
                } catch (err) {
                    alert(err);
                }
            } else {
                console.log(err);
            }
        })
    };
    render() {
        const { adding, index, addUser, changeAddState } = this.props;
        const { getFieldDecorator, validateFields, resetFields } = this.props.form;

        return (
            <Modal
                title="添加用户"
                visible={adding}
                okText="保存"
                onCancel={() => {
                    changeAddState(false);
                }
                }
                onOk={this.addUser.bind(this)}
                key={index}
                maskClosable={false}
            >
                <Form>
                    <FormItem
                        {...formItemLayout}
                        label="用户名"
                    >
                        {getFieldDecorator('name', {
                            rules: [{ required: true, message: '请填写用户名!' }],
                        })(
                            <Input placeholder="用户名"/>
                            )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="密码"
                    >
                        {getFieldDecorator('password', {
                            rules: [{ required: true,whitespace: true, pattern: /^(^(?![^A-Z]+$)(?![^a-z]+$)(?!\D+$))\w{8,100}$/, message: '请输入不少于8位大小写字母加数字的密码!' }],
                        })(
                            <Input placeholder="密码"/>
                            )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="权限"
                    >
                        {getFieldDecorator('role', {
                            rules: [{ required: true, message: '请选择权限!' }],
                        })(
                            <RadioGroup>
                                <Radio value={0}>普通用户</Radio>
                                <Radio value={1}>管理员</Radio>
                            </RadioGroup>
                            )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
};

const mapStateToProps = state => ({
    adding: state.user.userpageState.adding,
});

const mapDispatchToProps = dispatch => ({
    changeAddState: adding => dispatch(createShowAddAction(adding)),// 显示隐藏弹窗
    addUser: value => dispatch(addUser(value)), // 新增用户
    getList: params => dispatch(getList(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Add));



// WEBPACK FOOTER //
// ./components/sub-sider/user-add.js